var _circle, _path, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgShieldBadge = function SvgShieldBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D1C4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.056 8H10.944c-.794 0-1.437.655-1.437 1.455L9.5 18.858c0 .502.253.946.636 1.207L16 24l5.857-3.934c.383-.262.636-.706.636-1.208l.007-9.403c0-.8-.65-1.455-1.444-1.455zM16 22.255l-5.056-3.39v-9.41h10.112v9.403L16 22.254zm-1.452-5.397l-1.863-1.883L11.667 16l2.889 2.91 5.777-5.82-1.025-1.032-4.76 4.8z",
    fill: "#27272A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "#18181B"
  })));
};

export default SvgShieldBadge;